import { ReactNode } from "react";
import './modal_link.css'
import { useStore } from "../state/state.ts";
import ModalInfoGEG from "../modals/modal_info_geg.tsx";
import { ModalLinkBEG, ModalLinkGEG } from "./modal_link.tsx";
import { FOERDERUNG } from "../config.ts";

export default function GEGInfo(props:{BEG: number, GEG: number}){    
    if (!FOERDERUNG){
        return <p> gesetzlicher Mindeststandard U-Wert max. {props.GEG}</p>;
    }
    return  <p className="geg_info">Je kleiner die U-Wert ist, desto besser die Wärmedämmung.
          Für die BEG-Bundesförderung müssen bessere Dämmwerte erreicht werden.
          <br/><ModalLinkGEG/> ➔ gesetzlicher Mindeststandard U-Wert max. {props.GEG}
          <br/><ModalLinkBEG/> ➔ Bundesförderung U-Wert max. {props.BEG}
    </p>;  
}    